// 等级类型
import {
  ORGANIZATION_STATUS,
  ORGANIZATION_TURN_STATUS,
  USER_LEVEL_KEY,
  type Loose,
} from '~/api/interface'

export * from './dict'
export * from './rights'

export const B_SIDE_QRCODE = getFeUrl('/youyan-platform/jpeg/b-qrcode-1.jpeg')
export const C_SIDE_QRCODE = getFeUrl('/youyan-platform/jpeg/c-qrcode-1.jpeg')

// 用户等级
export enum USER_ADMIN {
  NORMAL = 1, // 成员
  ORG_ADMIN_USER = 2, // 企业超级管理员
  MANAGEMENT_PLATFORM = 3, // 后台管理员
  SUPER_ADMIN = 4, // 超级管理员
}

// const $t = i18n.global.t

// 用户等级对应中文
export const USER_ADMIN_TEXT = () => {
  const { $t } = useNuxtApp()
  return <Loose>{
    [USER_ADMIN.NORMAL]: $t('cheng-yuan'),
    [USER_ADMIN.ORG_ADMIN_USER]: $t('qi-ye-chao-ji-guan-li-yuan'),
    [USER_ADMIN.MANAGEMENT_PLATFORM]: $t('hou-tai-guan-li-yuan'),
    [USER_ADMIN.SUPER_ADMIN]: $t('ping-tai-chao-ji-guan-li-yuan'),
  }
}

// 对象类型
export enum OBJECT_TYPE {
  WORKS = 0, // 作品
  PRODUCT = 1, // 成品
  PERSON = 20, // 3D人物
  TEXT_ON_TEXT = 30, // 文生文
}
// 操作行为
export enum BEHAVIOR {
  CONTEXT_CREATE = 0, // 内容-一键生成
  CONTEXT_PREVIEW = 1, // 内容-预览
  CONTEXT_RENDERING = 2, // 内容-渲染视频
  CAMERA_CREATE = 10, // 镜头-一键生成
  CAMERA_PREVIEW = 11, // 镜头-预览
  CAMERA_RENDERING = 12, // 镜头-渲染视频
  EXPORT = 99, // 导出成品视频
  QUICKEN = 20, // 导出成品视频
  AI_PROMPT = 101, // AI优化prompt
  AI_GEN = 102, // AIGC生成脚本
  THREE_D_PERSON = 110, // 3D人物渲染
  CHAT_GET = 103, // 对话生成
  TEXT_OPTIMIZE = 104, // 文案优化
}

export type LevelInfo = {
  name: string
  background: string
  icon: string | null
  userLevelKey: USER_LEVEL_KEY
  textColor: string
}

// 等级图标颜色文案
export const USER_LEVEL = () => {
  const { $t } = useNuxtApp()
  return <Loose>{
    [USER_LEVEL_KEY.TASTE]: {
      name: $t('ti-yan-ban'),
      icon: null,
      background: 'linear-gradient(133.85deg, #EFF7FF 2.58%, #DAEBFF 78.28%)',
      textColor: '#2D476B',
      userLevelKey: USER_LEVEL_KEY.TASTE,
    },
    [USER_LEVEL_KEY.PERSONAL_LITE]: {
      name: $t('ru-men-ban'),
      icon: null,
      background: 'linear-gradient(125.92deg, #948DFF 18.41%, #B4AEFF 83.76%)',
      textColor: '#FFFFFF',
      userLevelKey: USER_LEVEL_KEY.TASTE,
    },
    [USER_LEVEL_KEY.PERSONAL]: {
      name: $t('ge-ren-ban-biao-zhun-ban'),
      icon: null,
      textColor: '#FFFFFF',
      background: 'linear-gradient(142.98deg, #753CF9 13.65%, #A380FD 99.32%)',
      userLevelKey: USER_LEVEL_KEY.PERSONAL,
    },
    [USER_LEVEL_KEY.TEAM_TASTE]: {
      name: $t('tuan-dui-ti-yan'),
      icon: null,
      textColor: '#2D476B',
      background: 'linear-gradient(133.85deg, #EFF7FF 2.58%, #DAEBFF 78.28%)',
      userLevelKey: USER_LEVEL_KEY.TEAM_TASTE,
    },
    [USER_LEVEL_KEY.TEAM_LIGHT]: {
      name: $t('tuan-dui-ru-men'),
      icon: null,
      background: '#351140',
      textColor: '#F6DDFB',
      userLevelKey: USER_LEVEL_KEY.TEAM_LIGHT,
    },
    [USER_LEVEL_KEY.ORG_STANDARD]: {
      name: $t('qi-ye-biao-zhun'),
      icon: null,
      background: '#735723',
      textColor: '#FFE9B1',
      userLevelKey: USER_LEVEL_KEY.ORG_STANDARD,
    },
    [USER_LEVEL_KEY.ORG_FLAGSHIP]: {
      name: $t('qi-ye-qi-jian'),
      icon: null,
      background: '#271D0B',
      textColor: '#FFE9B1',
      userLevelKey: USER_LEVEL_KEY.ORG_FLAGSHIP,
    },
  }
}

// 主体类型
export enum ORGANIZATION_TYPE {
  COMPANY,
  PERSON = 2,
}

export const ORGANIZATION_TYPE_MAP = () => {
  const { $t } = useNuxtApp()
  return <Loose>{
    [ORGANIZATION_TYPE.COMPANY]: $t('qi-ye'),
    [ORGANIZATION_TYPE.PERSON]: $t('ge-ren'),
  }
}
// 主体授权状态
export const ORGANIZATION_STATUS_MAP = () => {
  const { $t } = useNuxtApp()
  return <Loose>{
    [ORGANIZATION_STATUS.DOING]: $t('shen-he-zhong'),
    [ORGANIZATION_STATUS.SUCCESS]: $t('yi-ren-zheng'),
    [ORGANIZATION_STATUS.FAIL]: $t('ren-zheng-shi-bai'),
  }
}

// 转授权状态
export const ORGANIZATION_TURN_MAP = () => {
  const { $t } = useNuxtApp()
  return <Loose>{
    [ORGANIZATION_TURN_STATUS.WAIT]: $t('dai-tian-xie'),
    [ORGANIZATION_TURN_STATUS.SUCCESS]: $t('ren-zheng-wan-cheng'),
    [ORGANIZATION_TURN_STATUS.FAIL]: $t('ren-zheng-shi-bai'),
    [ORGANIZATION_TURN_STATUS.DOING]: $t('shen-he-zhong'),
    [ORGANIZATION_TURN_STATUS.OVER]: $t('yi-guo-qi'),
    [ORGANIZATION_TURN_STATUS.DISABLE]: $t('bu-ke-yong'),
  }
}

// 用户认证状态
export enum USER_VERIFY_STATUS {
  WAIT = 0, // 待审核
  SUCCESS = 1, // 成功
  FAIL = 2, // 失败
  CANCEL = 3, // 撤销
  RESEND = 4, // 重新认证
}

// 用户认证步骤
export enum USER_VERIFY_STEP {
  VERIFY = 0,
  WAIT = 1,
  RESULT = 2,
}

// 用户认证中文
export const USER_VERIFY_MAP = () => {
  const { $t } = useNuxtApp()
  return <Loose>{
    [USER_VERIFY_STATUS.WAIT]: $t('shen-he-zhong'),
    [USER_VERIFY_STATUS.SUCCESS]: $t('yi-ren-zheng'),
  }
}
export const PAGE_SIZE = 25

export enum PROJECT_RENDER_STATUS {
  SEGMENT_COMPLETE = 'segment_complete', // 渲染片段
  SEGMENT_INTERRUPT = 'segment_interrupt', // 渲染片段打断
  SEGMENT_ERROR = 'segment_error', // 渲染片段失败
  INIT_COMPLETE = 'init_complete', // 渲染完成
  INIT_FAIL = 'init_errot', // 渲染失败
  INIT_INTERRUPT = 'init_interrupt', // 渲染中断
}

// 作品渲染有视频可播放状态
export const PROJECT_PLAY_STATUS = [
  PROJECT_RENDER_STATUS.SEGMENT_COMPLETE,
  PROJECT_RENDER_STATUS.SEGMENT_INTERRUPT,
  PROJECT_RENDER_STATUS.INIT_COMPLETE,
  PROJECT_RENDER_STATUS.INIT_INTERRUPT,
]

export enum CONFIG_TYPE {
  // BEST_PRACTICES = 0, // 优秀作品
  HELP_CENTER = 1, // 帮助中心
  ACADEMY = 2, // 魔珐学院
  SEARCH = 3, // 搜索
}

export enum MARKDOWN_NAME {
  HELP_CENTER = 'knowledge_base',
  PROJECT_UPDATE = 'release_notes',
}

// 活动类型
export enum ACTIVITY_RANDOM_TYPE {
  SHANDONG_5G = 'shandong_innovation_competition', // 山东省5G创新大赛
}

// 从服务平台跳转到编辑器定位打开某个tab所需变量传递 参考文档地址https://rsjqcmnt5p.feishu.cn/wiki/KEbMwoS3OizyzrkqNvScMv9gnG9
export enum CONFIG_NAV {
  TEMPLATE = 'template', // 作品中心
  ACTOR = 'actor', // 3D人物
  CONTENT = 'content', // 3D生成
  CAMERA = 'camera', // 镜头优化
  VIDEO = 'video', // 视频包装
}

// 3D数字人
export enum ACTOR_NAV {
  CHARACTER = 'character', // 人物
  COLLECTION = 'collection', // 套装
  HAIR = 'hair', // 发型
  ACCESSORY = 'accessory', // 配饰
  MAKEUP = 'makeup', // 妆容
  ADJUST = 'adjust',
}
// export type ACTOR_NAV =
//   | 'character'
//   | 'collection'
//   | 'hair'
//   | 'accessory'
//   | 'makeup'
//   | 'adjust'

// 3D生成
export enum CONTENT_TABS {
  STUDIO = 'studio', // 场景
  CHARACTER = 'character', // 人物
  MEDIA = 'media', // 素材
  SCRIPT = 'script', // 脚本
}

// 视频包装
export enum VIDEO_BASE {
  AUDIO = 'audio', // 音乐
  SOUND_EFFECT = 'sound_effect', // 音效
  SUBTITLE_TEMPLATE = 'subtitle_template', // 字幕模板
  TEXT_TEMPLATE = 'text_template', // 文字模板
  STICKER = 'sticker', // 贴纸
  OPENING = 'opending', // 开场
  ENDING = 'ending', // 退场
}

type SUB_NAV_MAP = {
  [CONFIG_NAV.ACTOR]: string
  video: VIDEO_BASE
  content: CONTENT_TABS
  camera: never
  template: never
}

export type SUB_NAV = {
  [key in keyof SUB_NAV_MAP]: SUB_NAV_MAP[key]
}

// 搜索记录唯一标识符
export enum SEARCH_RECORD_UNIQUE {
  HELP_CENTER = 'help_center', // 帮助中心
  SITE = 'site', // 全站
  TEMPLATE = 'templates', // 作品中心
  CHARACTER = '3d_character', // 3D人物
}

// 全站&帮助中心热词枚举值
export enum SEARCH_HOT_WORD {
  HELP = 1,
  SITE = 3,
  // TEMPLATE = 3,
}

// 成片格式
export enum PIECES_VIDEO_TYPE {
  MP4 = 0,
  MOV = 1,
  WEBM = 2,
  MKV = 3,
}

export const PIECES_VIDEO_TYPE_TEXT = () => {
  return <Loose>{
    [PIECES_VIDEO_TYPE.MP4]: 'mp4',
    [PIECES_VIDEO_TYPE.MOV]: 'mov',
    [PIECES_VIDEO_TYPE.WEBM]: 'webm',
    [PIECES_VIDEO_TYPE.MKV]: 'mkv',
  }
}

// 成片分辨率
export const PIECES_VIDEO_RATE_TEXT: any = {
  '540x960': '540P',
  '1080x1920': '1080P',
  '1440x2560': '2K',
  '2160x3840': '4k',
  '960x540': '540P',
  '1920x1080': '1080P',
  '2560x1440': '2K',
  '3840x2160': '4k',
}

// 成片视频码率
export enum PIECES_VIDEO_BIT {
  LOW = 2,
  MEDIUM = 1,
  HIGH = 0,
}

export const PIECES_VIDEO_BIT_TEXT = () => {
  const { $t } = useNuxtApp()
  return <Loose>{
    [PIECES_VIDEO_BIT.LOW]: $t('geng-di'),
    [PIECES_VIDEO_BIT.MEDIUM]: $t('tui-jian'),
    [PIECES_VIDEO_BIT.HIGH]: $t('geng-gao'),
  }
}
